import React, { Component } from "react";
import { Button, Form, Modal } from "semantic-ui-react";
import countryOptions from "../../components/Countries";
import RuvixxForm from "../../components/RuvixxForm";

export default class NewRegionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      name: "",
      countries: [],
      error: false,
      errorMessage: "",
    };
  }

  handleOpen = () => {
    this.setState({ modalOpen: true, error: false, errorMessage: "" });
  };

  handleClose = () => {
    this.setState({ modalOpen: false, error: false, errorMessage: "" });
  };

  handleSubmit = async () => {
    const name = this.state.name;
    const countries = this.state.countries.join(",");

    this.setState({ error: false, errorMessage: "" });

    try {
      await this.props.handleSubmit(name, countries); // maybe-promise
      this.clearForm();
      this.handleClose();
    } catch (error) {
      this.setState({
        error: true,
        errorMessage: error.message || "Failed to create region",
      });
      throw error;
    }
  };

  cancel = () => {
    this.handleClose();
  };

  clearForm = () => {
    this.setState({
      name: "",
      countries: [],
    });
  };

  handleChange = (e, data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    const { name, countries, error, errorMessage } = this.state;
    return (
      <Modal
        size="small"
        trigger={
          <Button
            size="tiny"
            className="item-adder"
            content="New Region"
            onClick={this.handleOpen}
          />
        }
        open={this.state.modalOpen}
        onClose={this.handleClose}
        closeOnDimmerClick={false}
        closeIcon
      >
        <Modal.Header>New Region</Modal.Header>
        <Modal.Content>
          <RuvixxForm
            ready={!!name && countries.length !== 0}
            onSubmit={this.handleSubmit}
            onCancel={this.cancel}
            error={error}
            errorMessage={errorMessage}
          >
            <Form.Input
              inline
              name="name"
              label="Name"
              required
              onChange={this.handleChange}
            />
            <Form.Select
              inline
              search
              multiple
              clearable
              name="countries"
              label="Countries"
              placeholder="Select Country"
              onChange={this.handleChange}
              options={countryOptions}
              value={this.state.countries}
            />
          </RuvixxForm>
        </Modal.Content>
      </Modal>
    );
  }
}
